var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        eager: "",
        persistent: "",
        "hide-overlay": "",
        transition: "",
        "max-width": "400",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { class: _vm.dialogClass },
        [
          _c(
            "v-card",
            {
              ref: "card",
              staticClass: "card-collapsable",
              class: {
                "is-not-collapsed": !_vm.isCollapsed,
                "is-collapsed": _vm.isCollapsed,
                "animation-shake": _vm.isCollapsed,
                isMobile: _vm.is_mobile,
              },
              style: _vm.collapsedStyle,
            },
            [
              _c(
                "div",
                {
                  staticClass: "header touchable",
                  class: _vm.headerClass,
                  attrs: { role: "tab" },
                  on: {
                    pointerdown: _vm.startCollapsedDrag,
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggle.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "always-visible d-flex justify-center align-center",
                    },
                    [_vm._t("visible")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [_vm._t("title")], 2),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "icon-collapse mr-2",
                      attrs: { fab: "", small: "", depressed: "" },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticStyle: { transform: "scaleX(-1)" } },
                        [_vm._v("pin_invoke")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "overlay" }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "body" }, [_vm._t("body")], 2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions" },
                [_c("v-divider"), _vm._v(" "), _vm._t("actions")],
                2
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }